// extracted by mini-css-extract-plugin
module.exports = {"content":"MobileMenu_content__1CDUj","list":"MobileMenu_list__1Eg6u","main":"MobileMenu_main__3gusG","bottomFixed":"MobileMenu_bottomFixed__UVzGO"};